import logger from '../utils/logger';
import { useState, useEffect, useCallback } from 'react';
import { contectApprovalStatus } from '../api/api';
import { getLevelKey } from '../utils/getLevel';

export const useApprovalStatus = ({ processId, currentLevel, currentParentId, mode }) => {
  const [pendingApproval, setPendingApproval] = useState(null);
  const [loading, setLoading] = useState(false);

  const fetchApprovalStatus = useCallback(async () => {
    if (!processId || currentLevel === undefined) return;

    try {
      setLoading(true);
      const payload = {
        process_id: processId,
        level: getLevelKey(currentLevel, currentParentId),
      };

      const res = await contectApprovalStatus(payload);
      if (res?.data?.status === true) {
        setPendingApproval(res.data.data);
      } else {
        setPendingApproval(null);
      }
    } catch (error) {
      logger.error('Approval status error:', error);
      setPendingApproval(null);
    } finally {
      setLoading(false);
    }
  }, [processId, currentLevel, currentParentId]);

  useEffect(() => {
    fetchApprovalStatus();
  }, [fetchApprovalStatus, mode]);

  return { pendingApproval, loading, refetch: fetchApprovalStatus };
};
